import React from 'react';

export const ProductItemContext = React.createContext({
    type: null,
});
